// 개발 환경 체크
export const isDevelopment =
  process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost'

// 로깅 유틸리티
export const logger = {
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args)
    }
  },
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args)
    }
  },
  error: (...args) => {
    // 에러는 모든 환경에서 로깅
    console.error(...args)
  }
}
